import React from 'react';
import { connect } from 'react-redux';
import styles from './Error.module.scss';

const Error = ({ error }) =>
  error && (
    <div className={styles.container}>
      <div className={styles.model}>
        <h1>Error</h1>
        <p>{error.message}</p>
        <button
          className="button button--inline"
          onClick={() => window.location.reload(true)}
        >
          OK
        </button>
      </div>
    </div>
  );

export default connect(state => ({
  error: state.apiError
}))(Error);
